import { useEffect, useRef, useState } from "react";

/* ------------------------------ ICONS ------------------------------ */

const ICON_PATHS = {
  policy: (
    <>
      <path d="M4 21V8l8-5 8 5v13" />
      <path d="M9 21v-6h6v6" />
      <path d="M2 21h20" />
    </>
  ),
  bulb: (
    <>
      <path d="M9 18h6M10 22h4" />
      <path d="M12 2a7 7 0 0 0-4 12.7V18h8v-3.3A7 7 0 0 0 12 2Z" />
    </>
  ),
  book: (
    <>
      <path d="M4 4.5A2.5 2.5 0 0 1 6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5Z" />
      <path d="M4 17.5h16M9 7h7" />
    </>
  ),
  chat: (
    <>
      <path d="M21 15a3 3 0 0 1-3 3H8l-5 4V6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3Z" />
      <path d="M8 9h8M8 13h5" />
    </>
  ),
  globe: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18" />
      <path d="M12 3a15 15 0 0 1 0 18a15 15 0 0 1 0-18Z" />
    </>
  ),
  leaf: (
    <>
      <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8c0 5.5-4.78 10-10 10Z" />
      <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" />
    </>
  ),
  sprout: (
    <>
      <path d="M12 22V11" />
      <path d="M12 11C12 7 9 5 5 5c0 4 3 6 7 6Z" />
      <path d="M12 13c0-3.5 2.5-5.5 6-5.5c0 3.5-2.5 5.5-6 5.5Z" />
      <path d="M8 22h8" />
    </>
  ),
  drop: (
    <>
      <path d="M12 2.5S5.5 9.5 5.5 14a6.5 6.5 0 0 0 13 0C18.5 9.5 12 2.5 12 2.5Z" />
      <path d="M9 15a3 3 0 0 0 3 3" />
    </>
  ),
  chain: (
    <>
      <path d="M10 13a5 5 0 0 0 7.1.1l2.8-2.8a5 5 0 0 0-7.1-7.1L11 4.9" />
      <path d="M14 11a5 5 0 0 0-7.1-.1l-2.8 2.8a5 5 0 0 0 7.1 7.1L13 19.1" />
    </>
  ),
  mail: (
    <>
      <rect x="2.5" y="4.5" width="19" height="15" rx="2.5" />
      <path d="m3 7 9 6 9-6" />
    </>
  ),
  phone: (
    <path d="M6.6 2.5h-2A2.1 2.1 0 0 0 2.5 4.9C3 12.9 11.1 21 19.1 21.5a2.1 2.1 0 0 0 2.4-2.1v-2a1.8 1.8 0 0 0-1.4-1.7l-2.8-.7a1.7 1.7 0 0 0-1.7.6l-1 1.2a14.5 14.5 0 0 1-5.4-5.4l1.2-1a1.7 1.7 0 0 0 .6-1.7l-.7-2.8a1.8 1.8 0 0 0-1.7-1.4Z" />
  ),
  pin: (
    <>
      <path d="M12 22s7-6.2 7-12A7 7 0 0 0 5 10c0 5.8 7 12 7 12Z" />
      <circle cx="12" cy="10" r="2.6" />
    </>
  ),
  download: (
    <>
      <path d="M12 3v12" />
      <path d="m7 11 5 5 5-5" />
      <path d="M4 20h16" />
    </>
  ),
  arrow: <path d="M5 12h14m-6-6 6 6-6 6" />,
  calendar: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2.5" />
      <path d="M3 10h18M8 3v4M16 3v4" />
    </>
  ),
  check: <path d="m4 12.5 5 5L20 6.5" />,
  wheat: (
    <>
      <path d="M12 22V9" />
      <path d="M12 9c0-2 1.5-3.5 3.5-4c0 2-1.5 3.5-3.5 4Z" />
      <path d="M12 9C12 7 10.5 5.5 8.5 5c0 2 1.5 3.5 3.5 4Z" />
      <path d="M12 14c0-2 1.5-3.5 3.5-4c0 2-1.5 3.5-3.5 4Z" />
      <path d="M12 14c0-2-1.5-3.5-3.5-4c0 2 1.5 3.5 3.5 4Z" />
    </>
  ),
  chevron: <path d="m6 9 6 6 6-6" />,
  users: (
    <>
      <circle cx="9" cy="8" r="3.4" />
      <path d="M2.5 20a6.5 6.5 0 0 1 13 0" />
      <path d="M16 5.2a3.4 3.4 0 0 1 0 5.6" />
      <path d="M17.5 14.2A6.5 6.5 0 0 1 21.5 20" />
    </>
  ),
  handshake: (
    <>
      <path d="m11 17 2 2a1.7 1.7 0 0 0 2.4-2.4" />
      <path d="m13.6 14.6 2.8 2.8a1.7 1.7 0 0 0 2.4-2.4l-4.6-4.6" />
      <path d="M3 8.5 6.5 5l3 1.5L13 5l4 3.5" />
      <path d="M3 8.5 8 15a1.8 1.8 0 0 0 2.7.2L14 12" />
      <path d="M21 8.5 17 12" />
    </>
  ),
  rss: (
    <>
      <path d="M4 11a9 9 0 0 1 9 9" />
      <path d="M4 4a16 16 0 0 1 16 16" />
      <circle cx="5" cy="19" r="1.4" />
    </>
  ),
  sort: (
    <>
      <path d="M4 7h11M4 12h8M4 17h5" />
      <path d="M18 7v10m0 0 3-3m-3 3-3-3" />
    </>
  ),
  tag: (
    <>
      <path d="M3 12.5V4a1 1 0 0 1 1-1h8.5a1 1 0 0 1 .7.3l7.5 7.5a1 1 0 0 1 0 1.4l-8.5 8.5a1 1 0 0 1-1.4 0L3.3 13.2a1 1 0 0 1-.3-.7Z" />
      <circle cx="7.5" cy="7.5" r="1.3" />
    </>
  ),
  news: (
    <>
      <path d="M4 5.5A1.5 1.5 0 0 1 5.5 4h11A1.5 1.5 0 0 1 18 5.5V19a1.5 1.5 0 0 0 1.5 1.5H6a2 2 0 0 1-2-2Z" />
      <path d="M19.5 20.5A1.5 1.5 0 0 0 21 19v-8h-3" />
      <path d="M7.5 8h7M7.5 11.5h7M7.5 15h4" />
    </>
  ),
  mic: (
    <>
      <rect x="9" y="2.5" width="6" height="11" rx="3" />
      <path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21M8.5 21h7" />
    </>
  ),
  quote: <path d="M9 7H5.5A2.5 2.5 0 0 0 3 9.5V13h6V7Zm0 0v4c0 3.5-2 5.5-5 6M21 7h-3.5A2.5 2.5 0 0 0 15 9.5V13h6V7Zm0 0v4c0 3.5-2 5.5-5 6" />,
};

export function Icon({ name, className = "h-6 w-6", strokeWidth = 1.7 }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {ICON_PATHS[name] || ICON_PATHS.leaf}
    </svg>
  );
}

/* --------------------------- ANIMATION HELPERS --------------------------- */

export function Reveal({ children, variant = "up", delay = 0, className = "" }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setShown(true);
            io.unobserve(e.target);
          }
        }),
      { threshold: 0.08, rootMargin: "0px 0px -50px 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  const base =
    variant === "left"
      ? "reveal-left"
      : variant === "right"
      ? "reveal-right"
      : variant === "zoom"
      ? "reveal-zoom"
      : "reveal";
  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${delay}ms` }}
      className={`${base} ${shown ? "is-visible" : ""} ${className}`}
    >
      {children}
    </div>
  );
}

export function CountUp({ value, duration = 1500 }) {
  const m = String(value).match(/^(\D*)(\d+)(.*)$/);
  const prefix = m ? m[1] : "";
  const target = m ? parseInt(m[2], 10) : 0;
  const suffix = m ? m[3] : String(value);
  const ref = useRef(null);
  const started = useRef(false);
  const [n, setN] = useState(0);
  useEffect(() => {
    const el = ref.current;
    if (!el || !m) return;
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting && !started.current) {
            started.current = true;
            const t0 = performance.now();
            const tick = (t) => {
              const p = Math.min((t - t0) / duration, 1);
              setN(Math.round(target * (1 - Math.pow(1 - p, 3))));
              if (p < 1) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
          }
        }),
      { threshold: 0.4 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [target, duration, m]);
  return (
    <span ref={ref}>
      {prefix}
      {m ? n : ""}
      {suffix}
    </span>
  );
}

/* ------------------------------ UI ATOMS ------------------------------ */

export const SERIF = { fontFamily: '"Fraunces", Georgia, "Times New Roman", serif' };

export function Eyebrow({ children, light = false, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.18em] ${
        light
          ? "border-white/30 bg-white/10 text-white"
          : "border-[#DA2128]/20 bg-[#FEF7F4] text-[#DA2128]"
      } ${className}`}
    >
      <span className="relative flex h-1.5 w-1.5">
        <span className="anim-pulse-ring absolute inline-flex h-full w-full rounded-full bg-[#F59C00]" />
        <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-[#F59C00]" />
      </span>
      {children}
    </span>
  );
}

export function SectionHeading({ eyebrow, title, subtitle, light = false, align = "center" }) {
  const centered = align === "center";
  return (
    <div className={centered ? "mx-auto max-w-3xl text-center" : "max-w-3xl"}>
      <Reveal>
        <Eyebrow light={light}>{eyebrow}</Eyebrow>
      </Reveal>
      <Reveal delay={80}>
        <h2
          style={SERIF}
          className={`mt-5 text-3xl font-bold leading-tight tracking-tight sm:text-4xl lg:text-[2.6rem] ${
            light ? "text-white" : "text-stone-900"
          }`}
        >
          {title}
        </h2>
      </Reveal>
      <Reveal delay={140}>
        <div
          className={`mt-5 flex items-center gap-2 ${centered ? "justify-center" : ""}`}
          aria-hidden="true"
        >
          <span className="h-[3px] w-10 rounded-full bg-[#DA2128]" />
          <span className="h-[3px] w-4 rounded-full bg-[#F59C00]" />
          <span className="h-[3px] w-2 rounded-full bg-[#DB6400]" />
        </div>
      </Reveal>
      {subtitle && (
        <Reveal delay={200}>
          <p
            className={`mt-5 text-base leading-relaxed sm:text-[17px] ${
              light ? "text-white/80" : "text-stone-600"
            }`}
          >
            {subtitle}
          </p>
        </Reveal>
      )}
    </div>
  );
}

export function BtnPrimary({ children, href = "#", icon = "arrow", className = "" }) {
  return (
    <a
      href={href}
      className={`shine-parent group inline-flex items-center gap-2.5 rounded-full bg-[#DA2128] px-7 py-3.5 text-sm font-semibold text-white shadow-lg shadow-[#DA2128]/25 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#DB2628] hover:shadow-xl ${className}`}
    >
      <span className="relative z-10">{children}</span>
      <Icon
        name={icon}
        className="relative z-10 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
        strokeWidth={2.2}
      />
    </a>
  );
}

export function BtnGhost({ children, href = "#", icon = "arrow", light = false }) {
  return (
    <a
      href={href}
      className={`group inline-flex items-center gap-2.5 rounded-full border px-7 py-3.5 text-sm font-semibold transition-all duration-300 hover:-translate-y-0.5 ${
        light
          ? "border-white/40 bg-white/10 text-white hover:border-white hover:bg-white hover:text-[#DA2128]"
          : "border-stone-300 bg-white text-stone-800 hover:border-[#DA2128] hover:text-[#DA2128]"
      }`}
    >
      {children}
      <Icon
        name={icon}
        className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
        strokeWidth={2.2}
      />
    </a>
  );
}

export function FieldPattern({ className = "", opacity = 0.05 }) {
  return (
    <svg
      className={`pointer-events-none absolute inset-0 h-full w-full ${className}`}
      style={{ opacity }}
      aria-hidden="true"
    >
      <defs>
        <pattern id="agri-grid" width="46" height="46" patternUnits="userSpaceOnUse">
          <path d="M23 8v30" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
          <path d="M23 16c0-3 2-5 5-5.6c0 3-2 5-5 5.6Z" stroke="currentColor" strokeWidth="1.1" fill="none" />
          <path d="M23 16c0-3-2-5-5-5.6c0 3 2 5 5 5.6Z" stroke="currentColor" strokeWidth="1.1" fill="none" />
          <path d="M23 24c0-3 2-5 5-5.6c0 3-2 5-5 5.6Z" stroke="currentColor" strokeWidth="1.1" fill="none" />
          <path d="M23 24c0-3-2-5-5-5.6c0 3 2 5 5 5.6Z" stroke="currentColor" strokeWidth="1.1" fill="none" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#agri-grid)" />
    </svg>
  );
}

export function Breadcrumb() {
  return (
    <nav
      aria-label="Breadcrumb"
      className="absolute left-4 top-4 z-20 hidden sm:left-8 sm:top-6 sm:block"
    >
      <ol className="flex flex-wrap items-center gap-2 rounded-full border border-white/15 bg-white/80 px-4 py-2 text-[11px] font-bold uppercase tracking-wide text-[#141419] shadow-lg shadow-black/10 backdrop-blur-md">
        <li>
          <a href="#home" className="inline-flex items-center gap-1.5 transition-colors hover:text-[#DA2128]">
            <svg
              viewBox="0 0 24 24"
              className="h-3.5 w-3.5"
              fill="none"
              stroke="currentColor"
              strokeWidth={2.2}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 10.5 12 3l9 7.5" />
              <path d="M5 10v10h14V10" />
              <path d="M9 20v-6h6v6" />
            </svg>
            Home
          </a>
        </li>
        <li className="text-black/30">&rsaquo;</li>
        <li>
          <a href="#overview" className="transition-colors hover:text-[#DA2128]">
            Sectors
          </a>
        </li>
        <li className="text-black/30">&rsaquo;</li>
        <li className="rounded-full bg-[#DA2128] px-3 py-1 text-white">Agriculture &amp; Food Processing</li>
      </ol>
    </nav>
  );
}
